<template>
    <div class="image-cropper">
        <div class="crop-canvas" ref="canvas">
            <div class="crop-area" ref="container">

                <div class="crop-image" draggable="false" ref="image" :style="{
                    width: (cropBounds.width * imageRatio)+'px',
                    height: (cropBounds.height * imageRatio)+'px'
                }">
                    <img :src="imageData" draggable="false" :style="{
                        position: cropBounds.width < image.width ? 'absolute' : 'relative',
                        top: -((boundsOffset[1] + cropBounds.top)/2) * imageRatio + 'px',
                        left: -((boundsOffset[0] + cropBounds.left)/2) * imageRatio + 'px',
                        width: (image.width * imageRatio)+'px',
                        height: (image.height * imageRatio)+'px'
                    }">

                    <div class="crop-maximum" draggable="false" v-if="cropBounds.width < image.width" :style="{
                        top: (((boundsOffset[1] - cropBounds.top) / 2) * imageRatio) - 4 + 'px',
                        left: (((boundsOffset[0] - cropBounds.left) /2) * imageRatio) - 4 + 'px',
                        width: (cropBounds.width * imageRatio)+'px',
                        height: (cropBounds.height * imageRatio)+'px'
                    }"></div>
                </div>

                <div class="crop-controls" draggable="true" ref="controls" :style="{
                    top: cropTop+'px',
                    left: cropLeft+'px',
                    width: cropWidth+'px',
                    height: cropHeight+'px'
                }">
                    <div class="crop-control crop-top-left" draggable="true">
                        <div class="crop-info">
                            <span v-if="dragStartPosition !== null">
                                {{ -Math.round((crop.left - dragStartCrop.left - dragStartPosition[0]) + dragStartPosition[0]) }},
                                {{ -Math.round((crop.top - dragStartCrop.top - dragStartPosition[1]) + dragStartPosition[1]) }}
                            </span>
                        </div>
                    </div>
                    <div class="crop-control crop-top-right" draggable="true">
                        <div class="crop-info">
                            <span v-if="dragStartPosition !== null">
                                {{ Math.round(((crop.left + crop.width) - (dragStartCrop.left + dragStartCrop.width) - dragStartPosition[0])
                                + dragStartPosition[0]) }},
                                {{ -Math.round((crop.top - dragStartCrop.top - dragStartPosition[1]) + dragStartPosition[1]) }}
                            </span>
                        </div>
                    </div>
                    <div class="crop-control crop-bottom-left" draggable="true">
                        <div class="crop-info">
                            <span v-if="dragStartPosition !== null">
                                {{ -Math.round((crop.left - dragStartCrop.left - dragStartPosition[0]) + dragStartPosition[0]) }},
                                {{ Math.round(((crop.top + crop.height) - (dragStartCrop.top + dragStartCrop.height) - dragStartPosition[1])
                                + dragStartPosition[1]) }}
                            </span>
                        </div>
                    </div>
                    <div class="crop-control crop-bottom-right" draggable="true">
                        <div class="crop-info">
                            <span v-if="dragStartPosition !== null">
                                {{ Math.round(((crop.left + crop.width) - (dragStartCrop.left + dragStartCrop.width) - dragStartPosition[0])
                                + dragStartPosition[0]) }},
                                {{ Math.round(((crop.top + crop.height) - (dragStartCrop.top + dragStartCrop.height) - dragStartPosition[1])
                                + dragStartPosition[1]) }}
                            </span>
                        </div>
                    </div>

                    <div class="crop-info-bar top">{{ Math.round(crop.width) }}</div>
                    <div class="crop-info-bar left">{{ Math.round(crop.height) }}</div>
                    <div class="crop-info-bar bottom">{{ Math.round(crop.width) }}</div>
                    <div class="crop-info-bar right">{{ Math.round(crop.height) }}</div>
                </div>

            </div>
        </div>


        <div class="image-info">
            <div v-if="cropBounds.width < image.width" :class="{
                'image-info-block': true,
                'same': Math.round(cropBounds.width) === Math.round(crop.width) && Math.round(cropBounds.height) === Math.round(crop.height),
            }">
                <strong>New Size</strong>
                <br/>
                {{ Math.round(cropBounds.width) }} x {{ Math.round(cropBounds.height) }}px
            </div>
            <div v-else :class="{
                'image-info-block': true,
                'same': Math.round(image.width) === Math.round(crop.width) && Math.round(image.height) === Math.round(crop.height),
            }">
                <strong>New Size</strong>
                <br/>
                {{ Math.round(image.width) }} x {{ Math.round(image.height) }}px
            </div>
            <div v-if="cropBounds.width < image.width" :class="{
                'image-info-block': true,
                'changed': Math.round(cropBounds.width) !== Math.round(crop.width) || Math.round(cropBounds.height) !== Math.round(crop.height),
                'same': Math.round(cropBounds.width) === Math.round(crop.width) && Math.round(cropBounds.height) === Math.round(crop.height),
            }">
                <strong>Cropped Size</strong> <br/>
                {{ Math.round(crop.width) }} x {{ Math.round(crop.height) }}px
            </div>
            <div v-else="cropBounds.width < image.width" :class="{
                'image-info-block': true,
                'changed': Math.round(image.width) !== Math.round(crop.width) || Math.round(image.height) !== Math.round(crop.height),
                'same': Math.round(image.width) === Math.round(crop.width) && Math.round(image.height) === Math.round(crop.height),
            }">
                <strong>Cropped Size</strong> <br/>
                {{ Math.round(crop.width) }} x {{ Math.round(crop.height) }}px
            </div>
        </div>

        <h3 class="subtitle has-text-centered">
            <a @click="showResult = !showResult">
                {{ showResult ? 'Hide Preview' : 'Show Preview' }}
            </a>
        </h3>
        <div v-if="showResult">
            <div class="crop-preview center" :style="{
                width: Math.round(crop.width / cropRatio)+'px',
                height: Math.round(crop.height / cropRatio)+'px'
            }">
                <img :src="imageData" :style="{
                    width: Math.round(image.width / cropRatio)+'px',
                    height: Math.round(image.height / cropRatio)+'px',
                    top: -Math.round(crop.top / cropRatio)+'px',
                    left: -Math.round(crop.left / cropRatio)+'px'
                }">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'image-cropper',
        mounted() {
            this.loadImage();

            this.$refs.controls.addEventListener('dragstart', this.dragStart, false)
            this.$refs.controls.addEventListener('drag', this.drag, false)
            this.$refs.controls.addEventListener('dragend', this.dragEnd, false)
            this.$bus.$on('resize', this.getContainerSize)
        },
        beforeDestroy() {
            this.$refs.controls.removeEventListener('dragstart', this.dragStart, false)
            this.$refs.controls.removeEventListener('drag', this.drag, false)
            this.$refs.controls.removeEventListener('dragend', this.dragEnd, false)
            this.$bus.$off('resize', this.getContainerSize)
        },
        props: {
            imageData: {type: [String]},
            bounds: {type: [Object], default: null},
            startCrop: {type: [Object], default: null},
            minSize: {
                type: [Object], default: () => {
                    return { // in image pixels
                        height: 100,
                        width: 100,
                    }
                }
            }
        },
        data() {
            return {
                showResult: false,
                image: { // image pixels
                    height: 0,
                    width: 0,
                },
                container: { // screen pixels
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                },
                canvas: { // screen pixels
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                },
                crop: { // in image pixels
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                },
                cropBounds: { // in image pixels
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                    minWidth: 100,
                    minHeight: 100,
                },
                dragTarget: 'move',
                dragOffset: null, // in image pixels
                dragStartPosition: null, // in screen pixels
                dragStartCrop: { // in image pixels
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                },
                zoom: 100,
            }
        },
        computed: {
            imageRatio() {
                let width = this.cropBounds.width < this.image.width ? this.cropBounds.width : this.image.width
                let ratio = width > this.canvas.width ? this.canvas.width / width : 1
                let scale = (1 - ratio)
                ratio     = 1 - (scale / (this.zoom / 100))
                return ratio;
            },
            cropRatio () {
                return this.crop.width > this.canvas.width ? this.crop.width / this.canvas.width : 1
            },
            boundsOffset () {
                return this.cropBounds.width < this.image.width ? [this.cropBounds.left, this.cropBounds.top] : [0, 0]
            },
            cropTop() {
                return (this.crop.top - ((this.boundsOffset[1] + this.cropBounds.top) / 2)) * this.imageRatio
            },
            cropLeft() {
                return (this.crop.left - ((this.boundsOffset[0] + this.cropBounds.left) / 2)) * this.imageRatio
            },
            cropHeight() {
                return this.crop.height * this.imageRatio
            },
            cropWidth() {
                return this.crop.width * this.imageRatio
            },
        },
        methods: {
            loadImage() {
                this.loaded  = false
                let image    = new Image();
                image.src    = this.imageData
                image.onload = () => {
                    this.image.height = image.height
                    this.image.width  = image.width
                    this.setup()
                }
            },
            setup() {
                this.getContainerSize()

                // set crop boundaries
                if (this.bounds !== null) {
                    this.cropBounds = Object.assign({}, this.bounds, {
                        minWidth: this.minSize.width,
                        minHeight: this.minSize.height,
                    })
                } else {
                    this.cropBounds.width     = this.image.width
                    this.cropBounds.height    = this.image.height
                    this.cropBounds.minWidth  = Math.min(this.minSize.width, this.image.width)
                    this.cropBounds.minHeight = Math.min(this.minSize.height, this.image.height)
                }

                // set initial crop
                if (this.startCrop !== null) {
                    this.crop = Object.assign({}, this.startCrop)
                } else {
                    this.crop.top    = 0
                    this.crop.left   = 0
                    this.crop.height = this.image.height
                    this.crop.width  = this.image.width
                }

                this.loaded = true
            },
            getContainerSize() {
                let container         = this.$refs.container.getBoundingClientRect()
                this.container.top    = container.top
                this.container.left   = container.left
                this.container.height = container.height
                this.container.width  = container.width
                let canvas            = this.$refs.canvas.getBoundingClientRect()
                this.canvas.top       = canvas.top + 50
                this.canvas.left      = canvas.left + 50
                this.canvas.height    = canvas.height - 100
                this.canvas.width     = canvas.width - 100
            },
            getDragTarget(target) {
                if (target.className.indexOf('crop-controls') !== -1) this.dragTarget = 'move'
                if (target.className.indexOf('crop-top-left') !== -1) this.dragTarget = 'top-left'
                if (target.className.indexOf('crop-top-right') !== -1) this.dragTarget = 'top-right'
                if (target.className.indexOf('crop-bottom-left') !== -1) this.dragTarget = 'bottom-left'
                if (target.className.indexOf('crop-bottom-right') !== -1) this.dragTarget = 'bottom-right'
            },
            dragStart(e) {
                // hide dragging ghost image
                e.dataTransfer.effectAllowed = 'none'
                e.dataTransfer.dropEffect    = 'none'
                e.dataTransfer.setDragImage(window.document.createElement('div'), 0, 0)

                this.getDragTarget(e.target)

                // start drag
                this.getContainerSize()
                this.dragStartPosition = [Math.round(e.clientX - this.container.left), Math.round(e.clientY - this.container.top)]
                this.dragStartCrop     = Object.assign({}, this.crop)
            },
            drag(e) {
                e.preventDefault()
                this.getDragOffset(e)
                this.dragCrop()
            },
            dragEnd(e) {
                e.preventDefault()
                // one last positioning
                this.getDragOffset(e)
                this.dragCrop()
                // reset drag
                this.dragStartPosition = null
                this.dragOffset        = null
                this.dragStartCrop     = null
            },
            getDragOffset(event) {
                let newPosition = [event.clientX - this.container.left, event.clientY - this.container.top]
                let offsetX     = -(this.dragStartPosition[0] - newPosition[0])
                let offsetY     = -(this.dragStartPosition[1] - newPosition[1])
                this.dragOffset = [offsetX / this.imageRatio, offsetY / this.imageRatio]
            },
            dragCrop() {
                let newLeft   = this.crop.left
                let newTop    = this.crop.top
                let newWidth  = this.crop.width
                let newHeight = this.crop.height
                if (this.dragTarget === 'move') {
                    newLeft = Math.min(Math.max(this.dragStartCrop.left + this.dragOffset[0], this.cropBounds.left),
                        (this.cropBounds.left + this.cropBounds.width) - this.crop.width)
                    newTop  = Math.min(Math.max(this.dragStartCrop.top + this.dragOffset[1], this.cropBounds.top),
                        (this.cropBounds.top + this.cropBounds.height) - this.crop.height)
                }
                if (this.dragTarget === 'top-left') {
                    let left           = this.dragStartCrop.left + this.dragOffset[0]
                    let top            = this.dragStartCrop.top + this.dragOffset[1]
                    let width          = this.dragStartCrop.width - this.dragOffset[0]
                    let height         = this.dragStartCrop.height - this.dragOffset[1]
                    let leftNegative   = left < this.cropBounds.left ? this.cropBounds.left - left : 0
                    let topNegative    = top < this.cropBounds.top ? this.cropBounds.top - top : 0
                    let widthNegative  = width < this.cropBounds.minWidth ? this.cropBounds.minWidth - width : 0
                    let heightNegative = height < this.cropBounds.minHeight ? this.cropBounds.minHeight - height : 0
                    newLeft            = Math.max(left - widthNegative, this.cropBounds.left)
                    newTop             = Math.max(top - heightNegative, this.cropBounds.top)
                    newWidth           = Math.max(width - leftNegative, this.cropBounds.minWidth)
                    newHeight          = Math.max(height - topNegative, this.cropBounds.minHeight)
                }
                if (this.dragTarget === 'top-right') {
                    let top            = this.dragStartCrop.top + this.dragOffset[1]
                    let width          = this.dragStartCrop.width + this.dragOffset[0]
                    let height         = this.dragStartCrop.height - this.dragOffset[1]
                    let topNegative    = top < this.cropBounds.top ? top - this.cropBounds.top : 0
                    let heightNegative = height < this.cropBounds.minHeight ? this.cropBounds.minHeight - height : 0
                    newTop             = Math.max(top - heightNegative, this.cropBounds.top)
                    newWidth           = Math.min(Math.max(width, this.cropBounds.minWidth), this.cropBounds.left + this.cropBounds.width - this.crop.left)
                    newHeight          = Math.min(Math.max(height - topNegative, this.cropBounds.minHeight), this.cropBounds.height)
                }
                if (this.dragTarget === 'bottom-right') {
                    let width  = this.dragStartCrop.width + this.dragOffset[0]
                    let height = this.dragStartCrop.height + this.dragOffset[1]
                    newWidth   = Math.min(Math.max(width, this.cropBounds.minWidth), this.cropBounds.left + this.cropBounds.width - this.crop.left)
                    newHeight  = Math.min(Math.max(height, this.cropBounds.minHeight), this.cropBounds.top + this.cropBounds.height - this.crop.top)
                }
                if (this.dragTarget === 'bottom-left') {
                    let left          = this.dragStartCrop.left + this.dragOffset[0]
                    let width         = this.dragStartCrop.width - this.dragOffset[0]
                    let height        = this.dragStartCrop.height + this.dragOffset[1]
                    let leftNegative  = left < this.cropBounds.left ? this.cropBounds.left - left : 0
                    let widthNegative = width < this.cropBounds.minWidth ? this.cropBounds.minWidth - width : 0
                    newLeft           = Math.max(left - widthNegative, this.cropBounds.left)
                    newWidth          = Math.max(width - leftNegative, this.cropBounds.minWidth)
                    newHeight         = Math.min(Math.max(height, this.cropBounds.minHeight), this.cropBounds.top + this.cropBounds.height - this.crop.top)
                }

                this.crop.top    = newTop
                this.crop.left   = newLeft
                this.crop.width  = newWidth
                this.crop.height = newHeight

                this.$emit('cropped', {
                    top: Math.round(this.crop.top),
                    left: Math.round(this.crop.left),
                    width: Math.round(this.crop.width),
                    height: Math.round(this.crop.height),
                })
            },
        }
    };
</script>


<style lang="scss" rel="stylesheet/scss">

    .image-cropper {
        margin-bottom: 2rem;
    }

    .image-info {
        text-align: center;
        margin: 1rem auto;
    }

    .image-info-block {
        display: inline-block;
        font-size: 0.75rem;
        background: rgba(0, 0, 0, 0.05);
        color: #888;
        strong {
            color: inherit;
        }
        padding: 0.5rem;
        white-space: nowrap;
        transition: background 0.5s ease;
        transition-property: background, color;
        &.same {
            color: #333;
            background: #A8D667;
        }
        &.changed {
            color: #FFF;
            background: #F15A5C;
        }
    }

    .crop-canvas {
        overflow: hidden;
        padding: 50px;
        text-align: center;
        margin: 1rem auto;
    }

    .crop-area {
        display: inline-block;
        position: relative;
        font-size: 0;
        user-select: none;
        text-align: left;
    }

    .crop-image {
        position: relative;
        img {
            max-width: initial
        }
    }

    .crop-maximum {
        position: absolute;
        z-index: 1;
        border: 4px solid #F00;
        border-radius: 4px;
        box-sizing: content-box;
        pointer-events: none;
        user-select: none;
    }

    .crop-controls {
        position: absolute;
        box-shadow: 0 0 100vw 100vw rgba(0, 0, 0, 0.9);
        border: 1px solid #FFF;
        &:hover {
            cursor: move;
        }
        &:active {
            cursor: pointer;
        }
    }

    .crop-control {
        position: absolute;
        z-index: 2;
        display: inline-block;
        border: 0 solid rgba(255, 255, 255, .5);
        font-size: 0.75rem;
        color: #FFF;
        transition: border 0.25s ease;
        .crop-info {
            position: relative;
        }
        span {
            position: absolute;
            display: block;
            width: 5rem;
            white-space: nowrap;
        }
        &:hover {
            cursor: pointer;
        }
    }

    .crop-top-left, .crop-top-right {
        &:hover {
            border-bottom-color: #F15A5C;
        }
    }

    .crop-bottom-left, .crop-bottom-right {
        &:hover {
            border-top-color: #F15A5C;
        }
    }

    .crop-top-left {
        border-left: 24px solid transparent;
        border-bottom-width: 24px;
        top: -24px;
        left: -24px;
        span {
            text-align: right;
            top: -15px;
            left: -70px;
        }
    }

    .crop-bottom-left {
        border-left: 24px solid transparent;
        border-top-width: 24px;
        bottom: -24px;
        left: -24px;
        span {
            text-align: right;
            bottom: -15px;
            left: -70px;
        }
    }

    .crop-top-right {
        border-right: 24px solid transparent;
        border-bottom-width: 24px;
        top: -24px;
        right: -24px;
        span {
            top: -15px;
            right: -70px;
        }
    }

    .crop-bottom-right {
        border-right: 24px solid transparent;
        border-top-width: 24px;
        bottom: -24px;
        right: -24px;
        span {
            bottom: -15px;
            right: -70px;
        }
    }

    .crop-info-bar {
        position: absolute;
        line-height: 20px;
        font-size: 0.75rem;
        color: #FFF;
        &.top {
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
        }
        &.left {
            top: 50%;
            left: -30px;
            transform: translateY(-50%);
            text-align: right;
        }
        &.bottom {
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
        }
        &.right {
            top: 50%;
            right: -30px;
            transform: translateY(-50%);
        }
    }

    .crop-preview {
        position: relative;
        display: block;
        &.center {
            margin: 0 auto;
        }
        overflow: hidden;
        img {
            position: absolute;
            max-width: initial;
        }
    }
</style>



// WEBPACK FOOTER //
// ImageCropper.vue?ee4942be